// Header.tsx
import React, { ReactNode } from "react";
import "./Header.css";

interface HeaderProps {
  children: ReactNode;
}

const Header: React.FC<HeaderProps> = ({ children }) => {
  return <header className="app-header">{children}</header>;
};

export default Header;
